import create from "zustand";
import { clubBasicInfoIntialState } from "../common/constants/club.constants";

import {
  IClubBasicInfo,
  IClubTreasury,
  IMembersRights,
  IVault,
  IWithdrawalMembersInfo,
} from "../common/interfaces/clubs.interface";
import { IDetailNftData } from "../common/interfaces/common.interface";

interface IClubsData {
  clubBasicInfo: IClubBasicInfo;
  numberOfMembers: number | undefined;
  treasury: IClubTreasury | undefined;
  stakeCount: number | undefined;
  vault: IVault | undefined;
  memberRights: IMembersRights | undefined;
  userRole: string | undefined;
  initialLoading: boolean;
  membersNfts: IDetailNftData[] | undefined;
  withdrawalMembersInfo: IWithdrawalMembersInfo[] | undefined;
}

interface IClubsStore extends IClubsData {
  setVault: (vault: IVault) => void;
  setStakeCount: (stakeCount: number) => void;
  setTreasury: (treasury: IClubTreasury) => void;
  updateClubBasicInfo: (clubBasicInfo: IClubBasicInfo) => void;
  setNumberOfMembers: (numberOfMembers: number) => void;
  setMemberRights: (memberRights: IMembersRights | undefined) => void;
  setUserRole: (userRole: string | undefined) => void;
  setMembersNfts: (membersNfts: IDetailNftData[] | undefined) => void;
  setWithdrawalMembersInfo: (
    withdrawalMembersInfo: IWithdrawalMembersInfo[]
  ) => void;
  resetState: () => void;
  toggleInitialLoading: (initialLoading: boolean) => void;
}

const initialState = {
  clubBasicInfo: clubBasicInfoIntialState,
  numberOfMembers: undefined,
  treasury: undefined,
  stakeCount: undefined,
  vault: undefined,
  memberRights: undefined,
  userRole: undefined,
  //TODO@milica-monke-merge: For monke false, for main true
  initialLoading: false,
  membersNfts: undefined,
  withdrawalMembersInfo: undefined,
};

export const clubsStore = create<IClubsStore>((set) => ({
  ...initialState,
  setVault: (vault: IVault | undefined) => set(() => ({ vault })),
  setStakeCount: (stakeCount: number) => set(() => ({ stakeCount })),
  setTreasury: (treasury: IClubTreasury) => set(() => ({ treasury })),
  updateClubBasicInfo: (clubBasicInfo: IClubBasicInfo) =>
    set(() => ({ clubBasicInfo })),
  setNumberOfMembers: (numberOfMembers: number) =>
    set(() => ({ numberOfMembers })),
  setMemberRights: (memberRights: IMembersRights | undefined) =>
    set(() => ({ memberRights })),
  setUserRole: (userRole: string | undefined) => set(() => ({ userRole })),
  setMembersNfts: (membersNfts: IDetailNftData[] | undefined) =>
    set(() => ({ membersNfts })),
  setWithdrawalMembersInfo: (withdrawalMembersInfo: IWithdrawalMembersInfo[]) =>
    set(() => ({ withdrawalMembersInfo })),
  resetState: () => set(() => initialState),
  toggleInitialLoading: (initialLoading: boolean) =>
    set(() => ({ initialLoading })),
}));
